(function ($, njm) {
    'use strict';

    njm.views.disclaimer = Backbone.View.extend({

        events: {
        },

        /**
         * Initialize
         */
        initialize: function () {
            var pageDisclaimers = {};
            var me = this;
			
			this.$('.container').text('').removeClass('placeholder');
			//console.log($(this).find('.container').text());
			
            (function populateDisclaimers() {
                var totalDisclaimerCount;
                var pageDisclaimersArray = [];
                //populate an object of the disclaimers on the page
                $('sup[data-disclaimer-name]').each(function () {
                    var disclaimerName = $(this).attr('data-disclaimer-name').toLowerCase().replace(/\s/g, "");
                    var disclaimerContent = $(this).attr('data-disclaimer-value');
                    if (!pageDisclaimers[disclaimerName]) {
                        pageDisclaimers[disclaimerName] = {};
                        pageDisclaimers[disclaimerName].disclaimer = disclaimerContent;
                    }
                });

                //count the number of disclaimers on the page and set the type of symbol to be used
                pageDisclaimersArray = Object.keys(pageDisclaimers);
                totalDisclaimerCount = pageDisclaimersArray.length;
                //disclaimerType = totalDisclaimerCount < 0 ? "asterisks" : "";

                //set the symbols for the disclaimers on the page
                for (var i = 0; i < totalDisclaimerCount; i++) {
                    var item = pageDisclaimers[pageDisclaimersArray[i]];
                    item.symbol = i + 1;
                    var disclaimerHtml = '<div class="disclaimer-text"><sup>' + item.symbol + '</sup>'+item.disclaimer +'</div >';
                    $('.comp-disclaimer.component .container').append(disclaimerHtml);
                }
                //populate the appropriate disclaimer symbol into the superscript tags
                $('sup[data-disclaimer-name]').each(function () {
                    var disclaimerName = $(this).attr('data-disclaimer-name').toLowerCase().replace(/\s/g, "");
                    $(this).html(pageDisclaimers[disclaimerName].symbol);
                });
                if (totalDisclaimerCount < 1) {
                    $('.comp-disclaimer.component').hide();
                }
            })()
               
        }
    });
})(jQuery, njm);
